<template>
  <div>
    <a-modal
      title="收货地址管理"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      :bodyStyle="{'max-height': '500px', 'overflow': 'auto'}"
    >
      <a-button
        type="primary"
        block
        @click="handleAddAddress"
      >
        新增收货地址
      </a-button>
      <div v-for="item in addAddressList" :key="item.id" :class="['address-box', {'active' : item.address_id === activeAddress.address_id}]" @click="selectAddress(item)">
        <div class="text">
          {{ item.receiver }} &nbsp;&nbsp; {{ item.phone }}<br>{{ item.address }}
        </div>
        <div class="btn-group">
          <a-button
            type="danger"
            shape="circle"
            icon="delete"
            class="mr-10"
            @click="handleDelete(item.address_id)"
          />
          <a-button
            type="primary"
            shape="circle"
            icon="edit"
            @click="handleEditAddress(item.address_id)"
          />
        </div>
      </div>
    </a-modal>
    <!-- 新增收货地址弹框 -->
    <add-address ref="addAddress" @ok="addEditAddressOk" />
  </div>
</template>

<script>
import AddAddress from '@/components/AddAddress'
import { getAddressList, postDelAddress } from '@/api/print'

export default {
  components: { AddAddress },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      addAddressList: [],
      activeAddress: {
        address_id: '',
        receiver: '',
        phone: '',
        address: ''
      }
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          address_id: '',
          receiver: '',
          phone: '',
          address: ''
        }
      }
    }
  },
  methods: {
    selectAddress(item) {
      this.activeAddress = item
    },
    showModal() {
      this.visible = true
      this.getList()
      if (this.value) {
        this.activeAddress = this.value
      }
    },
    handleOk() {
      this.visible = false
      this.confirmLoading = false
      this.$emit('input', this.activeAddress)
    },
    handleCancel(e) {
      this.visible = false
    },
    // 新增地址按钮
    handleAddAddress() {
      this.$refs.addAddress.showModal()
    },
    // 编辑地址按钮
    handleEditAddress(id) {
      console.log(id)
      this.$refs.addAddress.showModal(id)
    },
    // 删除地址
    handleDelete(address_id) {
      this.$confirm({
        title: '确定删除地址？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk: () => {
          this.postDelAddress(address_id)
        }
      })
    },
    // 获取地址列表
    getList () {
      getAddressList({
        page: 1,
        size: 10000
      })
        .then((res) => {
          if (res.code === 200) {
            const { data } = res
            this.addAddressList = data
          }
        })
        .catch((e) => {
          this.$message.error('获取地址列表失败')
        })
    },
    // 删除地址
    postDelAddress (address_id) {
      postDelAddress({
        address_id
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('删除地址成功')
            this.getList()
          }
        })
        .catch((e) => {
          this.$message.error('删除地址失败')
        })
    },
    // 新增编辑成功
    addEditAddressOk() {
      this.getList()
    }
  }
}
</script>
<style lang="less">
.address-box {
  border: 1px solid #eeeeee54;
  display: flex;
  padding: 10px;
  margin: 20px 0;
  position: relative;
  align-items: center;
  border-radius: 4px;
  &.active {
    border: 1px solid #2cffffb8;
    background: #409eff26;
    box-shadow: inset 0px 0px 8px 0px #2cffffb8;
  }
  .text {
    flex: 1 1 auto;
  }
  .btn-group {
    flex: none;
  }
}
</style>
